import * as React from 'react'
import { connect } from 'react-redux'

import { getParams } from '../../../../commons/utils'
import { CREATE_USER, TYPE_NAME } from '../../../actions/authActions'
import FooterButton from '../../molecules/FooterButton/FooterButton'
import Header from '../../molecules/Header/Header'
import NameInputForm from '../../molecules/NameInputForm/NameInputForm'

import { Dispatch } from 'redux'
import { CustomSpStore } from '../../../store'
import * as styles from './Signup.css'

interface SignupPropsFromState {
  name: string
  title: string
  isLoading: boolean
}

interface SignupPropsFromDispatch {
  typeName: (text: string) => void
  createParticipant: (data: any) => void
}

type SignupProps = SignupPropsFromState & SignupPropsFromDispatch

class Signup extends React.PureComponent<SignupProps> {
  public render() {
    const { name, title, typeName, createParticipant, isLoading } = this.props
    const isEnabled = name.length <= 20 && name.length > 0

    return (
      <div>
        <div className={styles.container}>
          <div className={styles.header}>
            <Header title={title} />
          </div>
          <div className={styles.lInputForm}>
            <NameInputForm handleChange={typeName} />
          </div>
        </div>
        <FooterButton
          isEnabled={isEnabled}
          handleClick={() => createParticipant({ name, ...getParams() })}
          isLoading={isLoading}
          id="submit-button"
        >
          次へ
        </FooterButton>
      </div>
    )
  }
}

const mapStateToProps = (state: CustomSpStore) => ({
  name: state.auth.name,
  title: state.projects.title,
  isLoading: state.auth.isLoading
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createParticipant: (data: any) => dispatch(CREATE_USER(data)),
  typeName: (name: string) => dispatch(TYPE_NAME(name))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Signup)
